export const endpoints = {
  getAll: () => "api/v1/internal/tags"
};
